export const setList = (state, payload) => state.list = payload
export const setTotalRevenue = (state, _) => {
  return state.totalRevenue = state.list.reduce((a, b) => a + (b.payment_amount || 0), 0)
}
